import { useCallback } from 'react';
import getEnabledBTCUnit from '~/client/hooks/currency/helpers/getEnabledBTCUnit';
import isBTC from '~/client/hooks/currency/helpers/isBTC';
import useSetWalletCurrency from '~/client/hooks/currency/useSetWalletCurrency';
import useToggleMbtc from '~/client/hooks/currency/useToggleMbtc';
import useWalletCurrency from '~/client/hooks/currency/useWalletCurrency';
import useSetInGameCurrency from '~/client/hooks/feature/inGameCurrency/useSetInGameCurrency';
import type { OtherFreebetRewardFragment } from './OtherFreebetRewardsQuery.generated';
import useGameContext from '../../context/Game/useGameContext';

const useHandleCurrencyChange = (reward?: OtherFreebetRewardFragment) => {
  const { closeGameSession } = useGameContext();
  const { toggleMbtc, isMBTCEnabled, isUBTCEnabled } = useToggleMbtc();
  const { setWalletCurrency } = useSetWalletCurrency();
  const walletCurrency = useWalletCurrency();
  const { setInGameCurrency } = useSetInGameCurrency();

  const handleCurrencyChange = useCallback(async () => {
    closeGameSession();
    const { currency, valueCurrency } = reward ?? {};
    const currentlyEnabledBTCUnit = getEnabledBTCUnit(
      isMBTCEnabled,
      isUBTCEnabled,
    );
    await setInGameCurrency(valueCurrency);

    if (
      valueCurrency &&
      isBTC(valueCurrency) &&
      currentlyEnabledBTCUnit &&
      currentlyEnabledBTCUnit !== valueCurrency
    ) {
      await toggleMbtc();
    }
    if (walletCurrency !== currency) {
      await setWalletCurrency(currency as Currency);
    }
  }, [
    closeGameSession,
    reward,
    setInGameCurrency,
    setWalletCurrency,
    toggleMbtc,
    walletCurrency,
    isMBTCEnabled,
    isUBTCEnabled,
  ]);

  return { handleCurrencyChange };
};

export default useHandleCurrencyChange;
